import ShortTruncateCopy from "components/common/RegistrationLinkCopy";
import { useState } from "react";
import { toast } from "react-hot-toast";

const CustomerRegistration = ({ client_id }: { client_id?: any }) => {
  const ClientLink = "https://" + window.location.hostname + "/customer/register/" + client_id;
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(ClientLink);
    setCopied(true);
    toast.success("Link copied to clipboard");
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div className="cr-root">
      {/* Header */}
      <div className="cr-header">
        <div className="cr-header-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
        </div>
        <div>
          <h3 className="cr-title">Customer Registration</h3>
          <p className="cr-subtitle">Share this link with customers to register under this client</p>
        </div>
      </div>

      {/* Link card */}
      <div className="cr-link-card">
        <div className="cr-link-icon-wrap">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
          </svg>
        </div>
        <div className="cr-link-info">
          <p className="cr-link-label">Registration URL</p>
          <code className="cr-link-url">{ClientLink}</code>
        </div>
        <button className={`cr-copy-btn${copied ? " cr-copy-btn--done" : ""}`} onClick={handleCopy}>
          {copied ? (
            <>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              Copied!
            </>
          ) : (
            <>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="9" y="9" width="13" height="13" rx="2"/>
                <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
              </svg>
              Copy Link
            </>
          )}
        </button>
      </div>

      {/* How to use */}
      <div className="cr-howto">
        <p className="cr-howto-title">How to use</p>
        <div className="cr-howto-steps">
          {[
            "Copy the registration link above",
            "Share it with your customers via email or messaging",
            "Customers fill in the registration form and submit",
            "Their account is automatically linked to this client",
          ].map((step, i) => (
            <div key={i} className="cr-howto-step">
              <div className="cr-step-num">{i + 1}</div>
              <span className="cr-step-txt">{step}</span>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        .cr-root { font-family: 'Plus Jakarta Sans', sans-serif; display: flex; flex-direction: column; gap: 20px; }
        .cr-header { display: flex; align-items: flex-start; gap: 14px; }
        .cr-header-icon { width: 44px; height: 44px; border-radius: 12px; background: linear-gradient(135deg,#eff6ff,#dbeafe); border: 1.5px solid #bfdbfe; display: flex; align-items: center; justify-content: center; color: #2563eb; flex-shrink: 0; }
        .cr-title { font-size: 16px; font-weight: 700; color: #0f172a; margin-bottom: 3px;line-height:22px }
        .cr-subtitle { font-size: 13px; color: #64748b; font-weight: 500; line-height: 1.5; }
        .cr-link-card { display: flex; align-items: center; gap: 14px; background: #f8fafc; border: 1.5px solid #e2e8f0; border-radius: 14px; padding: 18px 20px; flex-wrap: wrap; }
        .cr-link-icon-wrap { width: 40px; height: 40px; border-radius: 10px; background: #eff6ff; border: 1.5px solid #bfdbfe; display: flex; align-items: center; justify-content: center; color: #2563eb; flex-shrink: 0; }
        .cr-link-info { flex: 1; min-width: 0; }
        .cr-link-label { font-size: 11px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: .5px; margin-bottom: 4px; }
        .cr-link-url { font-family: 'Courier New', monospace; font-size: 12.5px; font-weight: 600; color: #1e293b; display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
        .cr-copy-btn { display: inline-flex; align-items: center; gap: 6px; font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px; font-weight: 700; padding: 10px 18px; border-radius: 10px; border: none; background: linear-gradient(135deg,#1d4ed8,#2563eb); color: #fff; cursor: pointer; box-shadow: 0 3px 12px rgba(37,99,235,.3); transition: all .15s; flex-shrink: 0; }
        .cr-copy-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(37,99,235,.38); }
        .cr-copy-btn--done { background: linear-gradient(135deg,#15803d,#16a34a) !important; box-shadow: 0 3px 12px rgba(22,163,74,.3) !important; }
        .cr-howto { background: #ffffff; border: 1px solid #e2e8f0; border-radius: 14px; padding: 20px; }
        .cr-howto-title { font-size: 13px; font-weight: 700; color: #374151; text-transform: uppercase; letter-spacing: .4px; margin-bottom: 14px; }
        .cr-howto-steps { display: flex; flex-direction: column; gap: 10px; }
        .cr-howto-step { display: flex; align-items: center; gap: 12px; }
        .cr-step-num { width: 26px; height: 26px; border-radius: 50%; background: linear-gradient(135deg,#eff6ff,#dbeafe); border: 1.5px solid #bfdbfe; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 700; color: #2563eb; flex-shrink: 0; }
        .cr-step-txt { font-size: 13.5px; color: #475569; font-weight: 500; }
      `}</style>
    </div>
  );
};

export default CustomerRegistration;